// extracted by mini-css-extract-plugin
module.exports = {"card":"CardOne_card__yOoaX","bigHeader":"CardOne_bigHeader__211Uv","button":"CardOne_button__d2ExT","image":"CardOne_image__2vHYN"};